const BUCKET_BASE_URL =
  "https://pub-87b43b20609d4a499729868595221a0c.r2.dev";
const DRAWINGS_BASE_URL = `${BUCKET_BASE_URL}/Tascam%20Drawings`;

const STEM_ART_URLS = {
  drums: `${DRAWINGS_BASE_URL}/DRUMS-KNOB%20(1).png`,
  bass: `${DRAWINGS_BASE_URL}/BASS-KNOB%20(1).png`,
  electric: `${DRAWINGS_BASE_URL}/GUITAR-KNOB%20(1).png`,
  nylon: `${DRAWINGS_BASE_URL}/NYLON.png`,
  keys: `${DRAWINGS_BASE_URL}/KEYS-KNOB%20(1).png`,
  percussion: `${DRAWINGS_BASE_URL}/PERC.png`,
  vibes: `${DRAWINGS_BASE_URL}/VIBES.png`,
  vocals: `${DRAWINGS_BASE_URL}/VOX-KNOB%20(2).png`,
  master: `${DRAWINGS_BASE_URL}/MF-KNOB%20(1).png`,
};

const CURRENT_TRACK_BASE_URLS = {
  oggBaseUrl: `${BUCKET_BASE_URL}/OGG`,
  aacBaseUrl: `${BUCKET_BASE_URL}/M4A`,
};

const TRACK_TWO_BASE_URLS = {
  oggBaseUrl: `${BUCKET_BASE_URL}/OGG`,
  aacBaseUrl: `${BUCKET_BASE_URL}/M4A`,
};

export const PLAY_BUTTONS_ON = `${DRAWINGS_BASE_URL}/BUTTONS-OFF.png`;
export const PLAY_BUTTONS_OFF = `${DRAWINGS_BASE_URL}/BUTTONS-ON.png`;
export const MASTER_FADER_IMAGE_URL = STEM_ART_URLS.master;
export const MASTER_FADER_LAYOUT = {
  leftPercent: 31,
  bottomPercent: 32,
};
export const CONTROLS_GLOBAL_BOTTOM_OFFSET = 2.7;
export const DEFAULT_SONG_ID = "ygmb";

const STEM_SLOTS = [
  {
    id: "drums",
    name: "Drums",
    imageUrl: STEM_ART_URLS.drums,
    leftPercent: 1.4,
    bottomPercent: 32,
    controlsLeftPercent: 12.2,
    controlsBottomPercent: 51.0,
  },
  {
    id: "bass",
    name: "Bass",
    imageUrl: STEM_ART_URLS.bass,
    leftPercent: 5.2,
    bottomPercent: 32,
    controlsLeftPercent: 16.0,
    controlsBottomPercent: 51.0,
  },
  {
    id: "electric",
    name: "Electric",
    imageUrl: STEM_ART_URLS.electric,
    leftPercent: 9,
    bottomPercent: 32,
    controlsLeftPercent: 19.7,
    controlsBottomPercent: 51.0,
  },
  {
    id: "nylon",
    name: "Nylon",
    imageUrl: STEM_ART_URLS.nylon,
    leftPercent: 12.6,
    bottomPercent: 32,
    controlsLeftPercent: 23.5,
    controlsBottomPercent: 50.9,
  },
  {
    id: "keys",
    name: "Keys",
    imageUrl: STEM_ART_URLS.keys,
    leftPercent: 16.2,
    bottomPercent: 32,
    controlsLeftPercent: 27.1,
    controlsBottomPercent: 50.9,
  },
  {
    id: "percussion",
    name: "Percussion",
    imageUrl: STEM_ART_URLS.percussion,
    leftPercent: 19.7,
    bottomPercent: 32,
    controlsLeftPercent: 30.9,
    controlsBottomPercent: 50.8,
  },
  {
    id: "vibes",
    name: "Vibes",
    imageUrl: STEM_ART_URLS.vibes,
    leftPercent: 23.3,
    bottomPercent: 32,
    controlsLeftPercent: 34.2,
    controlsBottomPercent: 50.9,
  },
  {
    id: "vocals",
    name: "Vocals",
    imageUrl: STEM_ART_URLS.vocals,
    leftPercent: 26.8,
    bottomPercent: 32,
    controlsLeftPercent: 37.8,
    controlsBottomPercent: 50.9,
  },
];

const CURRENT_TRACK_STATIC_BG_URL = `${DRAWINGS_BASE_URL}/VP-TASCAM-FRAME0.gif`;
const CURRENT_TRACK_GIF_URL = `${BUCKET_BASE_URL}/9TRACKTASCAM_ANIMATION.gif`;
const CURRENT_TRACK_ALBUM_ART_SELECTED_URL = `${BUCKET_BASE_URL}/Tascam%20Drawings/MR_YGMB_ON.png`;
const CURRENT_TRACK_ALBUM_ART_UNSELECTED_URL = `${BUCKET_BASE_URL}/Tascam%20Drawings/MR_YGMB_OFF.png`;

const TRACK_TWO_STATIC_BG_URL = CURRENT_TRACK_STATIC_BG_URL;
const TRACK_TWO_GIF_URL = CURRENT_TRACK_GIF_URL;
const TRACK_TWO_ALBUM_ART_SELECTED_URL = `${BUCKET_BASE_URL}/Tascam%20Drawings/MR_FOH_ON.png`;
const TRACK_TWO_ALBUM_ART_UNSELECTED_URL = `${BUCKET_BASE_URL}/Tascam%20Drawings/MR_FOH-Off.png`;

function buildAssetUrl(baseUrl, fileName) {
  return `${baseUrl}/${encodeURIComponent(fileName)}`;
}

function createStemSources(baseUrls, oggFileName, aacFileName) {
  return {
    oggUrl: oggFileName ? buildAssetUrl(baseUrls.oggBaseUrl, oggFileName) : undefined,
    aacUrl: aacFileName ? buildAssetUrl(baseUrls.aacBaseUrl, aacFileName) : undefined,
  };
}

function mergeStemSlots(stemOverrides) {
  return STEM_SLOTS.map(slot => ({
    ...slot,
    ...(stemOverrides[slot.id] || {}),
  }));
}

function createCurrentTrackStem(oggFileName, aacFileName) {
  return createStemSources(CURRENT_TRACK_BASE_URLS, oggFileName, aacFileName);
}

function createTrackTwoStem(fileBaseName, overrides = {}) {
  return {
    ...createStemSources(
      TRACK_TWO_BASE_URLS,
      `${fileBaseName}.ogg`,
      `${fileBaseName}.m4a`
    ),
    ...overrides,
  };
}

const CURRENT_TRACK_AUDIO = {
  drums: createCurrentTrackStem("YGMB DRUMS.ogg", "YGMB DRUMS.m4a"),
  bass: createCurrentTrackStem("YGMB BASS.ogg", "YGMB BASS.m4a"),
  electric: createCurrentTrackStem("YGMB EG.ogg", "YGMB EG.m4a"),
  nylon: createCurrentTrackStem("YGMB NYLON.ogg", "YGMB NYLON.m4a"),
  keys: createCurrentTrackStem("YGMB KEYS.ogg", "YGMB KEYS.m4a"),
  percussion: createCurrentTrackStem("YGMB PERC.ogg", "YGMB PERC.m4a"),
  vibes: createCurrentTrackStem("YGMB VIBES.ogg", "YGMB VIBES.m4a"),
  vocals: createCurrentTrackStem("YGMB VOCALS.ogg", "YGMB VOCALS.m4a"),
};

const TRACK_TWO_AUDIO = {
  drums: createTrackTwoStem("UCHI DRUM STEM", { name: "Drums" }),
  bass: createTrackTwoStem("UCHI BASS STEM", { name: "Bass" }),
  electric: createTrackTwoStem("UCHI GUITAR 1 STEM", {
    name: "Guitar 1",
    imageUrl: STEM_ART_URLS.electric,
  }),
  nylon: createTrackTwoStem("UCHI GUITAR 2 STEM", {
    name: "Guitar 2",
    imageUrl: STEM_ART_URLS.electric,
  }),
  keys: createTrackTwoStem("UCHI GUITAR 3 STEM", {
    name: "Guitar 3",
    imageUrl: STEM_ART_URLS.electric,
  }),
  percussion: createTrackTwoStem("UCHI GUITAR 4 STEM", {
    name: "Guitar 4",
    imageUrl: STEM_ART_URLS.electric,
  }),
  vibes: createTrackTwoStem("UCHI KEYS STEM", {
    name: "Keys",
    imageUrl: STEM_ART_URLS.keys,
  }),
  vocals: createTrackTwoStem("UCHI VOCAL STEM", { name: "Vocal" }),
};

export const SONGS = [
  {
    id: DEFAULT_SONG_ID,
    title: "You Get Me By",
    staticBgUrl: CURRENT_TRACK_STATIC_BG_URL,
    gifUrl: CURRENT_TRACK_GIF_URL,
    albumArtSelectedUrl: CURRENT_TRACK_ALBUM_ART_SELECTED_URL,
    albumArtUnselectedUrl: CURRENT_TRACK_ALBUM_ART_UNSELECTED_URL,
    stems: mergeStemSlots(CURRENT_TRACK_AUDIO),
  },
  {
    id: "track-02",
    title: "Force of Habit",
    staticBgUrl: TRACK_TWO_STATIC_BG_URL,
    gifUrl: TRACK_TWO_GIF_URL,
    albumArtSelectedUrl: TRACK_TWO_ALBUM_ART_SELECTED_URL,
    albumArtUnselectedUrl: TRACK_TWO_ALBUM_ART_UNSELECTED_URL,
    stems: mergeStemSlots(TRACK_TWO_AUDIO),
  },
];

export function getSongById(songId) {
  return SONGS.find(song => song.id === songId) || SONGS[0];
}

export function buildStemState(defaultValue) {
  return STEM_SLOTS.reduce((state, stem) => {
    state[stem.id] = defaultValue;
    return state;
  }, {});
}
